// const URL = process.env.NODE_ENV === 'production' ? 'http://183.230.255.39:9903':'http://183.230.255.39:9903';
const URL = process.env.NODE_ENV === 'production' ? 'http://pm.cqdky.com:9903':'http://pm.cqdky.com:9903';
// const URL = process.env.NODE_ENV === 'production' ? 'http://183.230.255.39:9903':'http://192.168.8.22:30080';
export default URL;